import AuthPage from './AuthPage.jsx'

function RegisterPage() {
  return <AuthPage mode="register" />
}

export default RegisterPage
